import { ApiResponse } from "@/types/api.types";
import baseApi from "./RootBaseApi";
import {
  Deployment,
  PaginatedDeploymentResponse,
  DeploymentActionData,
} from "@/types/deployement-management.types";

export const DeploymentService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllDeployments: builder.query<
      PaginatedDeploymentResponse,
      {
        page?: number;
        limit?: number;
        status?: number;
        search?: string;
        env?: string;
        env_type?: number;
        interface_type?: number;
      }
    >({
      query: (params) => ({
        url: "deployments",
        method: "GET",
        params: {
          page: params.page,
          limit: params.limit,
          status: params.status,
          search: params.search,
          env: params.env,
          env_type: params.env_type,
          interface_type: params.interface_type,
        },
      }),
      transformResponse: (response: PaginatedDeploymentResponse) => response,
      providesTags: ["Deployments"],
    }),

    getDeploymentById: builder.query<ApiResponse<Deployment>, string>({
      query: (id) => ({
        url: `deployments/${id}`,
        method: "GET",
      }),
      transformResponse: (response: ApiResponse<Deployment>) => response,
      providesTags: ["Deployment"],
    }),

    confirmDeployment: builder.mutation<
      ApiResponse<Deployment>,
      {
        id: string;
        update: DeploymentActionData;
      }
    >({
      query: ({ id, update }) => {
        const formData = new FormData();
        if (update.release_notes !== undefined)
          formData.append("release_notes", update.release_notes);
        if (update.status !== undefined)
          formData.append("status", String(update.status));
        if (update.attachment) formData.append("attachment", update.attachment);
        if (update.release_notes_url !== undefined)
          formData.append("release_notes_url", update.release_notes_url);
        return {
          url: `deployments/${id}/confirm`,
          method: "PATCH",
          data: formData,
          headers: { "Content-Type": "multipart/form-data" },
        };
      },
      transformResponse: (response: ApiResponse<Deployment>) => response,
      invalidatesTags: ["Deployments", "Deployment"],
    }),
  }),
});

export const {
  useGetAllDeploymentsQuery,
  useGetDeploymentByIdQuery,
  useConfirmDeploymentMutation,
} = DeploymentService;
